import { getTokenFromUrl } from '@shared/utils'

export const hasPermission = (permissions?: string[], permission?: string) => {
  return !!permissions?.includes?.(permission || '')
}

export const getAppUrl = (url: string) => {
  const token = getTokenFromUrl()

  if (!token) {
    console.error('Token is missing or invalid.')
    return ''
  }

  return url.startsWith(`/apps/crm/${token}`) ? url : `/apps/crm/${token}${url}`
}

export const getActivePath = (path: string) =>
  path?.split(getBasePath(path))?.[1]

export const getBasePath = (path: string) =>
  path.match(/^(.*?\/apps\/crm\/[^/]+)\//)?.[1] ?? path
